module.exports = __webpack_public_path__ + "img/03-2-1更好的体验.fe58ed7c.svg";